import { SearchOutlined } from '@ant-design/icons';
import { Flex, Input, Select, Space } from 'antd';

import {
  PF,
  SORT_OPTIONS,
} from '@app/pages/Warehouses/Inventory/components/InventoryCard/constants';
import { SortByEnum } from '@app/pages/Warehouses/Inventory/components/InventoryCard/types';
import type {
  DefaultConditionEnum,
  FiltersType,
  InProgressConditionEnum,
} from '@app/pages/Warehouses/Inventory/components/InventoryCard/types';

const { Compact } = Space;

export const Filters: FiltersType = ({
  values: { search, condition },
  onChangeFilters,
  conditionOptions,
}) => {
  return (
    <Flex wrap gap={12} className={`${PF}_filters`}>
      <Input
        addonBefore={<SearchOutlined />}
        placeholder="Введите название категории продукта"
        value={search}
        onChange={({ target }) => onChangeFilters('search', target.value)}
        className={`${PF}_filters_search`}
      />
      <Select<InProgressConditionEnum | DefaultConditionEnum>
        placeholder="Выберите условие"
        options={conditionOptions}
        value={condition}
        onSelect={(value) => onChangeFilters('condition', value)}
        className={`${PF}_filters_condition`}
      />
      <Compact>
        <Input
          value="Сортировка:"
          disabled
          className={`${PF}_filters_sorting_label`}
        />
        <Select<SortByEnum>
          defaultValue={SortByEnum.NAME}
          options={SORT_OPTIONS}
          onSelect={(value) => onChangeFilters('sortBy', value)}
          className={`${PF}_filters_sorting_select`}
        />
      </Compact>
    </Flex>
  );
};
